import { Spacer, Skeleton } from "@aviary";
import { SkeletonGoogleSSOButton } from "@shared/components/LoginOptions/GoogleSSOButton/SkeletonGoogleSSOButton";
import { SkeletonSignInForm } from "@unauthenticated/shared/components/SignInForm/SkeletonSignInForm";
import { SignInWrapper } from "@unauthenticated/shared/components/SignInWrapper/SignInWrapper";
import { SignInLayout } from "@unauthenticated/signupSignin/components/SignInLayout/SignInLayout";

const SkeletonSignInPage = () => {
  return (
    <SignInLayout>
      <SignInWrapper>
        <Skeleton type="typography" typographySize="h1" />
        <Spacer height="one" />
        <SkeletonGoogleSSOButton isOrTextRendered />
        <Spacer height="one" />
        <SkeletonSignInForm />
        <Spacer height="doubleHalf" />
        <Skeleton type="typography" typographySize="body" isFullWidth />
      </SignInWrapper>
    </SignInLayout>
  );
};

export { SkeletonSignInPage };
